export default "__VITE_ASSET__B4jmFDCb__"